import {People} from "@mui/icons-material"
import i18n from 'i18next';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //


const getCustomer = () => ({
    id: 'customer',
    type: 'group',
    children: [
        {
            id: 'customer',
            title: i18n.t('sidemenu.customerManagement'),
            type: 'item',
            url: '/customer',
            icon: People,
            breadcrumbs: false,
        },
    ]
});

export default getCustomer;